<template>
	<t-form-group>

		<CustomerSearchInput
			ref="customer"
			:selectedItems="selectedItems"
			width="100%"
			@input="searchString = $event"
			@select="addCustomer"
			@set:selected="setCustomers"
			v-on="$listeners"
		/>

		<t-tag-container
			v-if="hasItems(selectedItems)"
			:items="selectedItems"
			displayKey="name"
			@change="setCustomers"
			@tag-click="tagClick"
		>
			<template v-slot="{ item }">
				<t-location-tag-inner :item="item" displayKey="name" />
			</template>
		</t-tag-container>

	</t-form-group>
</template>

<script>
import CustomerSearchInput from '@/modules/customers/CustomerSearchInput';

export default {
	name: 'CustomersSelect',
	components: { CustomerSearchInput },

	props: {
		selectedItems: Array,
	},

	data() {
		return {
			searchString: '',
		};
	},

	methods: {
		addCustomer(customer) {
			let alreadyAdded = this.selectedItems.some(x => x.id === customer.id);
			if (alreadyAdded) return;
			this.setCustomers([...this.selectedItems, customer]);
		},

		setCustomers(customers) {
			this.$emit('change', customers);
		},

		tagClick(event) {
			this.$emit('tag-click', event);
		},

		hasItems(array) {
			return array && array.length;
		},
	}
};
</script>